import React,{useState,useEffect} from "react";
import _ from "lodash";
import axios from "axios";
import Utils from "../../common/Utils";
import JoditEditor from 'jodit-react';

const CqcContent = (props) => {

  const {id,title,mode} = props;

  const [loading, setLoading] = useState(false);
  const [content,setContent] = useState(_.get(props,'content',false));

  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
      ['link', 'image', 'video', 'formula'],
    
      [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction
    
      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'font': [] }],
      [{ 'align': [] }],
    
      ['clean']                                         // remove formatting button
    ]
  };

  useEffect(() => {
    if(mode==='print'){
      window.setTimeout(window.print,1000);
    }
    if(id > 0 && content===false){
      setLoading(true);
      axios.get(Utils.apiUrl(`cqcs/fetchcontent/${id}`), Utils.apiHeaders())
      .then(res => {
        setLoading(false);
          if(res.data.success){
            setContent(res.data.content);
          }
        })
      .catch(error => {
        setContent("Invalid content");
      });
    }else{
      //setContent("Invalid content");
    }
  },[]);

  useEffect(() => {
    if(_.get(props,'onChange',false)){
      props.onChange(content);
    }
  },[content]);

  return ( <div className="overflow-auto">
      {loading && <div>Loading...</div>}
      {content && (<>
        {mode==='edit' && <JoditEditor value={content} onChange={setContent} />}
        {mode!=='edit' && <div dangerouslySetInnerHTML={{__html: content}}></div>}
      </>)}
    </div>
  );
};

export default CqcContent;